export const Images = {
  companyLogo: require("./images/JustAct_Logo_TM_V4-01.png"),
  selectArrow: require("./images/selectArrow.svg"),
  checkBox: require("./images/checkbox.svg"),
  checkBoxSelected: require("./images/checkBoxSelected.svg"),
  dropDownArrow: require("./images/dropdownIcon.svg"),
  filefloder: require("./images/files-and-folders.svg"),
};
